import { AppDispatch, GetAppState } from '../../store';
import { shopPrefix } from '../../config';
import { GROUPBY_BUNDLES, SOURCE_SELECTIONLIST } from '../../store/constants';
import i18n from '../../../i18n';
import queryString from 'query-string';
import { deserializeFilter } from '../../shared/utils/deserializeFilter';
import { showNotification, TYPE_WARNING } from '../../store/notifications/actions';
import { http } from '../axios';
import { failSelectionlists, fetchSelectionlists } from '../../store/orderlist/actions';
import {
    isExcludeProductSelection,
    isIncludeProductSelection,
    ProductSelection
} from '../../shared/product-selection/ProductSelectionTypes';
import { nothingSelected } from '../../shared/product-selection/ProductSelectionUtils';

// TODO remove grouping state usage and change it into custom hook

type ProductsToGroupFromList = {
    sourceListId: string | undefined;
    productGroupId: number;
    productSelection: ProductSelection;
    cancelSelection: () => void;
};
export function addProductsToGroupFromList({
    sourceListId,
    productGroupId,
    productSelection,
    cancelSelection
}: ProductsToGroupFromList) {
    return (dispatch: AppDispatch, state: GetAppState) => {
        const endpoint = `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/selectionlist/:kind/copy`;
        const group = state().grouping;
        const bundleRef = group.id !== null && group.key === GROUPBY_BUNDLES ? group.id : undefined;

        if (nothingSelected(productSelection)) {
            throw new Error(i18n.t('notifications.nothingSelected.error'));
        }

        let requestdata = {
            pathParams: {},
            data: {}
        };

        try {
            const filterQueryParam = queryString.parse(window.location.search).filter;
            requestdata = {
                pathParams: {
                    productGroupId
                },
                data: {
                    ...requestdata.data,
                    amount: 1,
                    source: SOURCE_SELECTIONLIST,
                    sourceId: sourceListId,
                    bundleRef
                }
            };

            if (isIncludeProductSelection(productSelection)) {
                requestdata = {
                    ...requestdata,
                    pathParams: { ...requestdata.pathParams, kind: 'ids' },
                    data: {
                        ...requestdata.data,
                        lineItemKeys: productSelection.included
                    }
                };
            } else if (isExcludeProductSelection(productSelection)) {
                requestdata = {
                    ...requestdata,
                    pathParams: { ...requestdata.pathParams, kind: 'filter' },
                    data: {
                        ...requestdata.data,
                        filterRequest: deserializeFilter(filterQueryParam as string),
                        excludedLineItemKeys: productSelection.excluded
                    }
                };
            }
        } catch (error) {
            dispatch(showNotification(i18n.t('notifications.addProductsToGroup.warning'), TYPE_WARNING));
            return;
        }

        http.put(endpoint, requestdata.data, { pathParams: requestdata.pathParams })
            .then(() => {
                cancelSelection();
                dispatch(showNotification(i18n.t('notifications.addProductsToGroup.success')));
                dispatch(fetchSelectionlists());
                // TODO [PORTAL-3451] this seems to cause a broken update to the currently visible selection list.
                //  It looks like it is a quick'n'dirty hack to enforce an active selection list, but it causes the
                //  currently visible selection list meta data to get lost.
                //  If no unwanted side effect appear, the following line can be removed.
                // dispatch(changeActiveSelectionlist(sourceListId));
            })
            .catch(error => dispatch(failSelectionlists(error)));
    };
}
